// src/postplans/api/postPlansApi.js
const API_BASE = process.env.REACT_APP_API_BASE || "";

/** Wrapper: garantisce Error leggibile e JSON-check */
async function request(url, options) {
  const res = await fetch(url, options);
  const ct = res.headers.get("content-type") || "";
  const isJson = ct.includes("application/json");
  const data = isJson ? await res.json().catch(() => ({})) : await res.text().catch(() => "");

  if (!res.ok) {
    const msg =
      (isJson && (data.message || data.error)) ||
      `${res.status} ${res.statusText} @ ${url}`;
    throw new Error(msg);
  }
  return data;
}

function jsonHeaders() {
  return { "Content-Type": "application/json" };
}

/* ------- PLANS ------- */

export async function createPlan(payload) {
  return request(`${API_BASE}/api/post-plans`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
}

export async function getPlans() {
  return request(`${API_BASE}/api/post-plans`);
}

export async function getPlan(id) {
  return request(`${API_BASE}/api/post-plans/${id}`);
}

export async function updatePlan(id, payload) {
  return request(`${API_BASE}/api/post-plans/${id}`, {
    method: "PUT",
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
}

/* ------- EPISODES ------- */

export async function bulkUpsertEpisodes(planId, rows) {
  return request(`${API_BASE}/api/post-plans/${planId}/episodes:bulk`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(rows),
  });
}

/* ------- ROLES ------- */

export async function defineRole(planId, roleDef) {
  return request(`${API_BASE}/api/post-plans/${planId}/roles`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(roleDef),
  });
}

export async function defineCustomAllocations(planId, rows) {
  return request(`${API_BASE}/api/post-plans/${planId}/roles/custom`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(rows),
  });
}

export async function deleteRole(planId, roleKey) {
  return request(`${API_BASE}/api/post-plans/${planId}/roles/${encodeURIComponent(roleKey)}`, {
    method: "DELETE",
  });
}

export async function updateRole(planId, roleKey, payload) {
  return request(`${API_BASE}/api/post-plans/${planId}/roles/${encodeURIComponent(roleKey)}`, {
    method: "PUT",
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
}

export async function clearRoleCustom(planId, roleKey) {
  return request(`${API_BASE}/api/post-plans/${planId}/roles/${encodeURIComponent(roleKey)}/custom`, {
    method: "DELETE",
  });
}

/* ------- PRESET ROLES (routes/roles-map.js) ------- */

export async function getPresetRoles(group = "postproduzione") {
  return request(`${API_BASE}/api/post-plans/roles/preset?group=${encodeURIComponent(group)}`);
}

export async function addPresetRolesBulk(planId, labels) {
  return request(`${API_BASE}/api/post-plans/${planId}/roles/preset`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({ labels }),
  });
}

/* ------- GENERATE / SCHEDULE ------- */

export async function generateSchedule(planId) {
  return request(`${API_BASE}/api/post-plans/${planId}/generate`, {
    method: "POST",
    headers: jsonHeaders(),
  });
}

export async function getSchedule(planId) {
  return request(`${API_BASE}/api/post-plans/${planId}/schedule`);
}

/* ------- Alias legacy ------- */
export const listPlans = getPlans;
export const generatePlan = generateSchedule;

export async function aiSuggestRoles(planId, context = {}) {
  return request(`${API_BASE}/api/post-plans/${planId}/ai/suggest-roles`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(context),
  });
}

export async function aiOptimizeSchedule(planId, context = {}) {
  return request(`${API_BASE}/api/post-plans/${planId}/ai/optimize`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(context),
  });
}

export async function aiApplyOptimize(planId, proposal) {
  return request(`${API_BASE}/api/post-plans/${planId}/ai/optimize/apply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ proposal }),
  });
}

